import Component from "@ember/component"
import { action, get, set } from "@ember/object"
import { inject as service } from "@ember/service"
import { task } from "ember-concurrency"
export default class New extends Component {
  @service("ember-store") store

  @service rpc

  @service router

  id = null
  title = null
  longAbbreviation = null
  shortAbbreviation = null
  startYear = null
  endYear = null

  createSchoolYear = task(async () => {
    let result = await get(this, "rpc").execute("ADMIN_SCHOOL_YEAR_CREATE", {
      id: get(this, "id"),
      title: get(this, "title"),
      longAbbreviation: get(this, "longAbbreviation"),
      shortAbbreviation: get(this, "shortAbbreviation"),
      startYear: get(this, "startYear"),
      endYear: get(this, "endYear"),
    })
    this.router.transitionTo("admin.school-years.show", result.id)
  })

  @action
  setValue(key, value) {
    set(this, key, value)
  }

  @action
  onCreateSchoolYear() {
    this.createSchoolYear.perform()
  }
}
